
  function initProductFeatureGalleries() {
    const featureBlocks = document.querySelectorAll('[data-product-feature-block]');
    featureBlocks.forEach(block => {
      const thumbnails = block.querySelectorAll('.thumbnail');
      const mainImage = block.querySelector('.main-image-container img');
      if (!mainImage || thumbnails.length === 0) return;
      thumbnails.forEach(thumbnail => {
        if (thumbnail.tagName.toLowerCase() !== 'img') return;
        thumbnail.addEventListener('click', function() {
          block.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
          this.classList.add('active');
          const newImageSrc = this.getAttribute('data-full-src');
          if (newImageSrc) {
            mainImage.src = newImageSrc;
          }
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initProductFeatureGalleries);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initProductFeatureGalleries);
    document.addEventListener('shopify:block:select', initProductFeatureGalleries);
  }